import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SubordinateEmployee {
  employee_id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubordinatesService {
  private apiUrl = 'api/subordinates';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(): Observable<SubordinateEmployee[]> {
    return this.http.get<SubordinateEmployee[]>(this.apiUrl);
  }
}
